import { ParentsService } from './../../../../shared/services/parents.service';
import { IFaqGroup } from "./../../../../shared/components/faq-section-widget/models/Faq";
import { HelpCenterService } from "./../../../../shared/services/help-center.service";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { StudentsService } from "src/app/shared/services/students.service";
import { TourService } from 'ngx-ui-tour-md-menu';
import { MdMenuPlacement } from 'ngx-ui-tour-md-menu';
import * as m from 'moment';
import swal from 'sweetalert';
import { ProfileService } from 'src/app/shared/services/profile.service';
import { MatDialog } from '@angular/material/dialog';
import { TourModalComponent } from '../../tour-modal/tour-modal.component';
import { NotificationServices } from 'src/app/shared/services/notification.service';
import { ISpecialEdIep } from "./../../../../shared/components/student-list-widget/models/ISpecialEdIep";
import { ISpecialEdReports } from "./../../../../shared/components/student-list-widget/models/ISpecialEdReports";
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { url } from 'inspector';
import { environment } from "src/environments/environment";
import { StudentPbisService } from "src/app/shared/services/student-pbis.service";
import { AppConfigService } from 'src/app/services/app-config.service';
import { IStudentResume } from "./../../../../shared/components/student-list-widget/models/IStudentResume";
import { LoggingService } from "src/app/shared/services/logging.service";
import { ISpecialEdIepInfoItem} from "./../../../../shared/components/student-list-widget/models/ISpecialEdIepInfoResponse";


@Component({
  selector: "app-student-specialed",
  templateUrl: "./student-specialed.component.html",
  styleUrls: ["./student-specialed.component.scss"],
})
export class StudentSpecialedComponent implements OnInit {
  faq: IFaqGroup[] = null;
  studentId: string = null;
  student: IStudentResume = null;
  lastUpdated: any;
  specialEdRequest: ISpecialEdIep;
  showPage10: boolean = false;
  showIepNotification: boolean = false;
  showIepAssessment: boolean = false;
  downloadIepPdfUrl: string = null;
  showPage10url: string = null;

  iepNotifications: ISpecialEdIepInfoItem[] = [];
  iepAssessments: ISpecialEdIepInfoItem[] = [];
  showViewTxtPage10: boolean = false;
  showSignTxtPage10: boolean = false;
  showViewTxtNotification: boolean = false;
  showViewTxtAssessment: boolean = false;
  showSignTxtNotification: boolean = false;
  showSignTxtAssessment: boolean = false;
  userProfile: any = [];
  language: string;
  studentIEPStatus: boolean = false;

  constructor(
    private activeRoute: ActivatedRoute,
    private studentService: StudentsService,
    private helpService: HelpCenterService,
    private parentService: ParentsService,
    public tourService: TourService,
    private profileService: ProfileService,
    private notificationServices: NotificationServices,
    private loggingService: LoggingService,
    private sanitizer: DomSanitizer,
    private router: Router,
    private appConfig: AppConfigService
  ) {}

  ngOnInit(): void {
    this.userProfile = this.profileService.profile;
    this.language = this.userProfile.language === 'es' ? 'S' : 'E';

    this.activeRoute.parent.params.subscribe((data) => {
      this.studentId = data.studentId;
      this.lastUpdated = m();
    });

    this.student = this.studentService.currentStudent();

    const downloadIepPdfRequest = {
      StudentId: this.student.studentId,
      RequestType: "PRINTIEP",
      Lang: this.language,
      ParentEmail: this.profileService.profile.email,
      GuardianFirstName: this.profileService.profile.firstName,
      GuardianLastName: this.profileService.profile.lastName
    } as ISpecialEdIep;

    const page10Request = {
      StudentId: this.student.studentId,
      RequestType: "SIGNPG10",
      Lang: this.language,
      ParentEmail: this.profileService.profile.email,
      GuardianFirstName: this.profileService.profile.firstName,
      GuardianLastName: this.profileService.profile.lastName
    } as ISpecialEdIep;

    const iepNotificationRequest = {
      StudentId: this.student.studentId,
      RequestType: "SIGNNOTIFICATION",
      Lang: this.language,
      ParentEmail: this.profileService.profile.email,
      GuardianFirstName: this.profileService.profile.firstName,
      GuardianLastName: this.profileService.profile.lastName
    } as ISpecialEdIep;


    const iepAssessmentRequest = {
      StudentId: this.student.studentId,
      RequestType: "SIGNASSESSMENT",
      Lang: this.language,
      ParentEmail: this.profileService.profile.email,
      GuardianFirstName: this.profileService.profile.firstName,
      GuardianLastName: this.profileService.profile.lastName
    } as ISpecialEdIep;

    this.studentService
      .getSpecialEdIepInfo(
        this.studentId,
        downloadIepPdfRequest
      )
      .subscribe((res) => {

        if (
          res.status === true &&
          res.data &&
          res.data.length > 0 &&
          res.data[0].data
        ) {

          this.downloadIepPdfUrl =
            res.data[0].data.url;

        } else {

          this.downloadIepPdfUrl = null;

        }

      }); 

    this.studentService
      .getSpecialEdIepInfo(
        this.studentId,
        page10Request
      )
      .subscribe((res) => {

        if (
          res.status === true &&
          res.data &&
          res.data.length > 0
        ) {

          const page10 = res.data[0];
          if (
            page10.status === true && page10.data && page10.data.url
          ) {
            this.showPage10 = true;
            this.showPage10url = page10.data.url;
            this.setSignOrViewPage10(page10);
          } else {
            this.showPage10 = false;
            this.showPage10url = null;
          }
        } else {
          this.showPage10 = false;
          this.showPage10url = null;
        }
      });

    this.studentService
      .getSpecialEdIepInfo(
        this.studentId,
        iepNotificationRequest
      )
      .subscribe((res) => {
        if (
          res.status === true &&
          res.data &&
          res.data.length > 0
        ) {

         
          this.iepNotifications = res.data.filter(
              item =>
                item.status === true && item.data != null && !!item.data.url);
          this.showIepNotification = this.iepNotifications.length > 0;

        } else {
          this.iepNotifications = [];
          this.showIepNotification = false;
        }
      });

    this.studentService
      .getSpecialEdIepInfo(
        this.studentId,
        iepAssessmentRequest
      ).subscribe((res) => {
        if (
          res.status === true && res.data && res.data.length > 0
        ) {          
          this.iepAssessments =
            res.data.filter(
              item =>
                item.status === true &&
                item.data != null &&
                !!item.data.url
            );
          this.showIepAssessment =
          this.iepAssessments.length > 0;
        } else {
          this.iepAssessments = [];
          this.showIepAssessment = false;

        }

      });


    this.startTour();
  }
  setSignOrViewPage10(
    item: ISpecialEdIepInfoItem
  ): void {

    this.showSignTxtPage10 = false;
    this.showViewTxtPage10 = false;

    if (item.data?.signed === 1) {

      this.showViewTxtPage10 = true;

    } else {

      this.showSignTxtPage10 = true;

    }
  }
  setSIgnOrViewTextOnButtons(
    res: any,
    action: string
  ) {  
    const item =
      Array.isArray(res?.data)
        ? res.data[0]
        : res;

    const signed =
      item?.data?.signed;

    if (signed === 1) {

      if (action === "SignPage10") {

        this.showViewTxtPage10 = true;

      }
      else if (action === "Notification") {

        this.showViewTxtNotification = true;

      }
      else if (action === "Assessment") {

        this.showViewTxtAssessment = true;

      }

    }
    else {

      if (action === "SignPage10") {

        this.showSignTxtPage10 = true;

      }
      else if (action === "Notification") {

        this.showSignTxtNotification = true;

      }
      else if (action === "Assessment") {

        this.showSignTxtAssessment = true;

      }

    }
  }
  startTour() {
    const above: MdMenuPlacement = {
      yPosition: 'above'
    };
    const below: MdMenuPlacement = {
      yPosition: 'below'
    };
    const left: MdMenuPlacement = {
      xPosition: 'before'
    };
    const right: MdMenuPlacement = {
      xPosition: 'after'
    };


    this.tourService.initialize([
      {
        anchorId: 'start-tour',
        content: 'Here you will find resources related to special education.',
        title: 'Special Education',
        placement: right,
      },
    ]);
    if (this.profileService.profile.hasTour) {
      this.tourService.start();
    }
  }

  openTourConfirmation() {
    swal({
      title: `End Tour?`,
      icon: 'warning',
      text: "You can always turn it back on in the Preferences sidebar",
      buttons: {
        cancel: true,
        confirm: {
          text: 'Yes, turn off tour',
          value: true,
          visible: true,
          closeModal: true
        }
      }
    }).then((res) => {
        if (res) {
          const userProfile = this.profileService.profile;
          userProfile.hasTour = false;
          this.profileService.saveProfile(userProfile).subscribe(() => {
              this.profileService.getProfile().subscribe(() => {
                  this.notificationServices.showSuccessToast("Your profile has been updated");
                  window.location.reload();
                });
            });
        }
      });
  }
 

  GetNotification(
    type: number,
    documentUrl?: string
  ): void {   

    if (type === 1) {

      if (!this.showPage10url) {
        return;
      }
      this.studentService.getSpecialEdShowPage(this.studentId,this.showPage10url).subscribe((res) => {
          if (res.status === true) {
            this.loggingService.insertLogging(this.studentId,"SPED-SignPage10");
            this.openWindowWithForm(res.data.login_url,{
                token: res.data.jwt_token
              },
              'signwindow'
            );
          } else {

            this.showDocumentError(res.message);   }  });

    }

    else if (type === 2) {

      if (!documentUrl) {
        return;
      }

      this.studentService
        .getSpecialEdShowPage(
          this.studentId,
          documentUrl
        )
        .subscribe((res) => {

          if (res.status === true) {

            this.loggingService.insertLogging(
              this.studentId,
              "SPED-Notification"
            );

            this.openWindowWithForm(
              res.data.login_url,
              {
                token: res.data.jwt_token
              },
              'signwindow'
            );

          } else {

            this.showDocumentError(
              res.message
            );

          }

        });

    } 

    else if (type === 3) {

      if (!documentUrl) {
        return;
      }

      this.studentService
        .getSpecialEdShowPage(
          this.studentId,
          documentUrl
        )
        .subscribe((res) => {

          if (res.status === true) {

            this.loggingService.insertLogging(
              this.studentId,
              "SPED-Assessment"
            );

            this.openWindowWithForm(
              res.data.login_url,
              {
                token: res.data.jwt_token
              },
              'signwindow'
            );

          } else {

            this.showDocumentError(
              res.message
            );

          }

        });

    }
  }


 

  private showDocumentError(
    message: string
  ): void {

    swal({
      title:
        "There was a problem with the document.",
      text: message,
      icon: "info",
      button: "OK",
    } as any);

  }
  openWindowWithForm(
    loginUrl: string,
    data: { [key: string]: string },
    windowName: string
  ): void {

    const form =
      document.createElement('form');

    form.method = 'GET';
    form.target = windowName;
    form.action = loginUrl;


    for (const key in data) {

      if (data.hasOwnProperty(key)) {

        const input =
          document.createElement('input');

        input.type = 'hidden';
        input.name = key;
        input.value = data[key];

        form.appendChild(input);

      }

    }


    document.body.appendChild(form);

    window.open('', windowName);

    form.submit();

    document.body.removeChild(form);
  }



  openPdf(report: string) {

    this.getStudentIEPFlagStatus();

    setTimeout(() => {

      if (this.studentIEPStatus) {

        if (report === 'IEP') {

          this.loggingService.insertLogging(
            this.studentId,
            'SPED - IEP'
          );


          this.studentService
            .getSpecialEdIepDownloadPDF(
              this.studentId,
              this.downloadIepPdfUrl
            )
            .subscribe((res) => {

              if (res.status === true) {

                const blob =
                  this.blobPdfFromBase64String(
                    res.data
                  );

                const fileURL =
                  URL.createObjectURL(blob);

                window.open(fileURL);

              } else {

                swal({
                  title:
                    "There was a problem with the document.",
                  text: res.message,
                  icon: "info",
                  button: "OK",
                } as any);

              }

            });

        }

        else if (report === 'serviceReport') {

          this.loggingService.insertLogging(
            this.studentId,
            'SPED - Service Report'
          );


          const serviceReportRequest = {
            StudentId:
              this.student.studentId,
            ReportNo: "2901",
          } as ISpecialEdReports;


          this.studentService
            .getSpecialEdReport(
              this.studentId,
              serviceReportRequest
            )
            .subscribe((response) => {

              const blob =
                this.blobPdfFromBase64String(
                  response.pdfData
                );

              const fileURL =
                URL.createObjectURL(blob);

              window.open(fileURL);

            });

        }

        else if (
          report === 'absenceDetailsReport'
        ) {

          this.loggingService.insertLogging(
            this.studentId,
            'SPED - Absence Report'
          );


          const absenceDetailsRequest = {
            StudentId:
              this.student.studentId,
            ReportNo: "2936",
          } as ISpecialEdReports;


          this.studentService
            .getSpecialEdReport(
              this.studentId,
              absenceDetailsRequest
            )
            .subscribe((response) => {

              const blob =
                this.blobPdfFromBase64String(
                  response.pdfData
                );

              const fileURL =
                URL.createObjectURL(blob);

              window.open(fileURL);

            });

        }

      }

    }, 2000);
  }


  openEsy() {

    this.loggingService.insertLogging(
      this.studentId,
      'SPED - ESY'
    );

    this.parentService
      .getEsyLogin()
      .subscribe((response) => {

        window.open(response.url);

      });
  }


  blobPdfFromBase64String =
    (base64String) => {

      const byteArray =
        Uint8Array.from(
          atob(base64String)
            .split("")
            .map(
              (char) =>
                char.charCodeAt(0)
            )
        );

      return new Blob(
        [byteArray],
        {
          type: "application/pdf"
        }
      );

    };


  downloadConfirmDialog(report) {

    this.getStudentIEPFlagStatus();

    swal({
      text:
        "You are about to download a document that contains sensitive personal information",
      icon: "warning",
      buttons: [
        "Cancel",
        "Acknowledge"
      ],
    })
      .then((willAcknowledge) => {

        if (
          willAcknowledge &&
          this.downloadIepPdfUrl !== null
        ) {

          this.openPdf(report);

        }
        else {

          swal({
            text:
              "No Active IEP exists",
            icon: "warning",
            buttons: {
              cancel: {
                text: "Close",
                visible: true
              }
            }
          });

        }

      });

  }


  getStudentIEPFlagStatus() {

    if (this.downloadIepPdfUrl) {

      this.studentIEPStatus = true;

      return true;

    }
    else {

      this.studentIEPStatus = false;

      swal({
        text:
          "Your child is not in Special Education",
        icon: "warning",
        buttons: {
          cancel: {
            text: "Close",
            visible: true
          }
        }
      });


      return false;
    }
  }
}